import {
  Box,
  Text,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Title = styled(Text)`
  p {
    font-size: 28px;
  }
`

export const TableContainer = styled(Box)`
  background-color: ${({ theme }) => getThemeColor('white', theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  padding: ${({ theme }) => getThemeSpacing(2, theme)};
  flex-direction: column;

  overflow-x: auto;
  width: 100%;
`
